/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { SlatePlugin } from '../../../../slatePlugins/slatePlugins.types';
import {
  CARD_LOGIC_CELL_ELEMENT_TYPE,
  CARD_LOGIC_COLUMN_ELEMENT_TYPE,
  CARD_LOGIC_ELEMENT_TYPE,
  CARD_LOGIC_HEADER_CELL_ELEMENT_TYPE,
} from './model/constants';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const CardLogicElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(/* webpackExports: "CardLogicElementReadOnly" */ './Element/CardLogicElement').then(
      (mod) => mod.CardLogicElementReadOnly
    )
  )
);
const CardLogicCellElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "CardLogicCellElementReadOnly" */ './Element/Cell/CardLogicCellElement'
    ).then((mod) => mod.CardLogicCellElementReadOnly)
  )
);
const CardLogicColumnElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "CardLogicColumnElementReadOnly" */ './Element/Cell/CardLogicColumnElement'
    ).then((mod) => mod.CardLogicColumnElementReadOnly)
  )
);
const CardLogicHeaderCellElementReadOnly = withDynamicBlogEditorPluginHydration()(
  dynamicEditorComponent(() =>
    import(
      /* webpackExports: "CardLogicHeaderCellElementReadOnly" */ './Element/Header/CardLogicHeaderCellElement'
    ).then((mod) => mod.CardLogicHeaderCellElementReadOnly)
  )
);

export const CardLogicReadOnlyPlugin = (): SlatePlugin => {
  return {
    renderElement: (renderProps: RenderElementProps) => {
      const { element } = renderProps;
      switch (element.type) {
        case CARD_LOGIC_ELEMENT_TYPE: {
          return <CardLogicElementReadOnly {...renderProps} />;
        }
        case CARD_LOGIC_COLUMN_ELEMENT_TYPE: {
          return <CardLogicColumnElementReadOnly {...renderProps} />;
        }
        case CARD_LOGIC_HEADER_CELL_ELEMENT_TYPE: {
          return <CardLogicHeaderCellElementReadOnly {...renderProps} />;
        }
        case CARD_LOGIC_CELL_ELEMENT_TYPE: {
          return <CardLogicCellElementReadOnly {...renderProps} />;
        }
        default:
      }
    },
  };
};
